<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_OLD_CAMPAIGNS } from '@/store/types';
import campaignsApi from '@/services/apis/admin/campaigns.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = campaignsApi.useCampaignsQuery({
      page: props.page,
    });
    if (query.value) {
      store.commit(ADMIN_OLD_CAMPAIGNS.SET_OLD_CAMPAIGNS_QUERY, query);
    }
    return { query };
  },
};
</script>
